module.exports = __webpack_public_path__ + "static/media/bzsz.7beabac8.png";